import { render, staticRenderFns } from "./newsPage01.vue?vue&type=template&id=fb5def60&scoped=true&"
import script from "./newsPage01.vue?vue&type=script&lang=js&"
export * from "./newsPage01.vue?vue&type=script&lang=js&"
import style0 from "./newsPage01.vue?vue&type=style&index=0&id=fb5def60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5def60",
  null
  
)

export default component.exports